export const useConferenceStatus = () => {
    const ended = useRouteQuery('ended', false);
    
    const hasConferenceEnded = computed(() => {
        // Conference ends on September 5th, 2025 at 3PM PDT (UTC-7)
        const conferenceEndTime = new Date('2025-09-05T14:30:00-07:00');
        const currentTime = new Date();
        return ended.value ? true : currentTime > conferenceEndTime;
    });
    
    return {
        hasConferenceEnded
    };
};